import React, { memo, useRef } from "react";
import { useSpring, animated } from "@react-spring/web";
import { useTheme, useMotionConfig } from "@nivo/core";

const tooltipStyle = {
	pointerEvents: "none",
	position: "absolute",
	zIndex: 110,
	top: 0,
	left: 0,
	transform: "transition 1s"
};

const translate = (x, y) => {
	return `translate(${x}px, ${y}px)`;
};

const TooltipWrapper = memo(({ position, children, name = "only-periscope-graph" }) => {
	const theme = useTheme();
	const { animate, config: springConfig } = useMotionConfig();
	const lastValidCoords = useRef(null);

	let x = Math.round(position[0]);
	let y = Math.round(position[1]);

	const getScrollInfo = () => {
		const graphElement = document.querySelector(".main-graph");
		const contentElement = document.querySelector(".graph-content");
		return {
			scrollWidth: graphElement?.scrollWidth || 0,
			scrollLeft: contentElement?.scrollLeft || 0
		};
	};
	const scrollInfo = getScrollInfo();
	const isValid = x > 0 && y > 0;
	if (name === "only-periscope-graph" && isValid) {
		if (position[0] < 420) {
			x = -30;
			if (position[1] < 170) {
				y = 35;
			} else {
				y = -180;
			}
		} else if (position[0] > 440 && position[0] < 700) {
			if (scrollInfo.scrollWidth < 1000) {
				x = -160;
			} else {
				if (scrollInfo.scrollLeft === 0 || position[0] - scrollInfo.scrollLeft > 400) {
					x = -170;
				} else {
					x = -30;
				}
			}

			if (position[1] < 170) {
				y = 35;
			} else {
				y = -180;
			}
		} else if (position[0] > 700 && position[0] < 1000) {
			if (position[0] - document.querySelector(".graph-content").scrollLeft > 400) {
				x = -170;
			} else {
				x = -30;
			}
			if (position[1] < 170) {
				y = 35;
			} else {
				y = -180;
			}
		} else {
			x = -150;
			if (position[1] < 170) {
				y = 35;
			} else {
				y = -180;
			}
		}

		lastValidCoords.current = { x, y };
	} else if (lastValidCoords.current) {
		({ x, y } = lastValidCoords.current);
	}

	const animatedProps = useSpring({
		to: { transform: translate(x, y) },
		config: {
			...springConfig,
			tension: 200,
			friction: 25,
			mass: 1.2
		},
		immediate: !animate
	});

	const style = {
		...tooltipStyle,
		...theme.tooltip,
		transform: animatedProps.transform
	};

	return <animated.div style={style}>{children}</animated.div>;
});

TooltipWrapper.displayName = "TooltipWrapper";

export default TooltipWrapper;
